import { Step } from './Step';

export const AuthedPhoneNumber = () => {
  return (
    <div className={'mt-[-25px] flex w-full flex-col sm:flex-col sm:space-x-4 sm:px-10'}>
      <Step />
    </div>
  );
};
